module.exports = __webpack_public_path__ + "img/009222e6214bbdb3a1af2eb294d13247.png";